module.exports = __webpack_public_path__ + "img/whitecross.fa576178.svg";